import { JSX, ParentProps, Show, createMemo, splitProps } from "solid-js";
import { useTable } from "../TableContext";
import style from '../st-table.module.css'

export interface TableCellProps extends ParentProps {
    id?: string
}

export const Cell = (props: TableCellProps & JSX.HTMLAttributes<HTMLTableCellElement>) => {
    const table = useTable();
    const [_local, other] = splitProps(props, ['children', 'id', 'class'])

    const isVisible = createMemo(() => {
        if (!props.id) return true;
        return !table.hiddenColumnIds().includes(props.id);
    })

    return (
        <Show when={isVisible()}>
            <td class={`${style['st-table-row-cell']} ${props.class}`} {...other}>
                {props.children}
            </td>
        </Show>
    )
}
